const validate = (subject, ...required) => {
    required.forEach (field => {
        if (!subject[field]) throw new Error(`Field ${field} is required`);
    })
}

// eslint-disable-next-line 
const emailChecker = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

const checkEmailAddress = text => text.split(',').every(value => emailChecker.test(value));

const timestamp = () => new Date().valueOf() 

const all = (...args) => args?.every(value => value !== undefined);
const any = (...args) => args?.some(value => value !== undefined);

export {
    validate,
    timestamp,
    checkEmailAddress,
    all,
    any,
    emailChecker
}